<script>
	import { _ } from 'svelte-i18n';
</script>
<h2>Our Offer: Ticker "AION"</h2>

<p>Jesteśmy pierwszym Stake Poolem na platformie Cardano fizycznie zlokalizowanym w <strong>Polsce</strong>. 
Naszym celem jest zapewnienie tobie, za wszelką cenę, najwyższego możliwego zwrotu z inwestycji. Więcej na ten temat na panelu <strong>{$_("goal")}</strong>.</p>

<p>Czerpiąc co najlepsze z obu światów: z backupem działającym na VPS (Google) oraz główną fizyczną jednostką o parametrach: </p>
	<li>2X Xeon E5-2650v2 @ 2.60GHz (32 wątki)</li>
	<li>Pamięć SSD</li>
	<li>Podtrzymanie zasilania (UPS)</li>
	<li>32GB DDR3 RAM</li>
	<li>Z zawsze aktualną dystrybucją <strong>Arch Linux</strong></li>

	<p>W efekcie zapewniamy wartościowy wybór dla delegujących. Stake Pool z <strong>wysoką dostępnością</strong> VPS, 
	<strong>Rozproszoną architekturą</strong> dzięki kilku węzłom, 
	<strong>charakterystyczne pochodzenie</strong>, oraz zwiększoną 
	<strong>geopolityczną odpornością</strong> za sprawą naszej lokalizacji.</p>

<iframe width="500" height="360" frameborder="0" src="https://js.adapools.org/widget-dark.html?pool=a7b2a175b2e439acc125decd1f4d3a8e42a4744dcfe74dddf527c386"><a href="https://adapools.org/pool/a7b2a175b2e439acc125decd1f4d3a8e42a4744dcfe74dddf527c386">Detail</a></iframe>

<p>Jeśli masz jakieś wątpliwości, czy to dobry wybór, zapoznaj się z naszym tokiem rozumowania, który zmotywował nas do stworzenia tego stake poola</p>

<h2>Uzasadnienie</h2>

<p>Siła kryptowaluty w dużym stopniu zależy od decentralizacji, która pozwala bronić się jej przed wieloma zagrożeniami, takimi jak:</p>
<li>Sybil attack — agresja ze strony "złośliwych" bytów np. stake pool'i</li>
<li>DDoS — Blokada usług przez przeciążenie sieci</li>
<li>51% atak — gdy większość oddelegowanej stawki (stake) znajduje się pod kontrolą małej grupy ludzi</li>

<p>Jako delegujący masz możliwość poprawić żywotność i wytrwałość Cardano przez świadome i odpowiedzialne wybieranie pool'i które spełniają pewne kryteria:</p>

<h3>Nie polegają kompletnie na usługach VPS (prywatne serwery w chmurze)</h3>
<img src="single-point-of-failure.png" alt="Single Point of Failure" style="float:right;margin-top=30px" width="150px" class="img">
<p>Operatorzy często idą na łatwiznę, używając wirtualnych serwerów, Google, Amazon AWS itp. To podejście, choć ułatwia obsługę i gwarantuje wysoką dostępność, to odbywa się to kosztem centralizacji wszystkich pool'i, które korzystają z tych usług. Tworzy to ryzyko wyłączenia dużej części sieci przez np. jednostki rządowe, czy nawet awarię techniczą infrastruktury dostawcy. Inną kwestią jest mniejsze wykorzystanie różnorodności sprzętowej, co zapobiegałoby atakom wymierzonym w konkretne architektury sprzętowe.</p>

<h3>Zwiększają decentralizację przez wyróżnienie się geograficznie i kulturowo</h3>
<img src="decentralization.png" alt="Decentralization" style="float:left;margin-top=30px" width="150px" class="img">
<p>Centralizacja może nastąpić na wielu poziomach. Nie trywialnym przykładem poza agregacją kontroli i wpływów (wiele pool'i pod kontrolą jednostki), jest lokalizacja sprzętu w jednym miejscu (serwerownie VPS) i wykorzystywanie takiego samego oprogramowania. Ponadto często pomijanym źródłem centralizacji jest ideologia, etniczne pochodzenie, wiek, płeć, wiara, przeświadczenia, język, filozofia i wiele innych. Społeczna dywersyfikacja jest ważnym elementem sukcesu każdej krytopowaluty. Zdecentralizowany system używany przez wszystkich, powinien być utrzymywany przez wielu!</p>

<h3>Nie są przepełnione</h3>
<img src="saturation.png" alt="Over saturation" style="float:right;margin-top=30px" width="150px" class="img">
<p>Obecny projekt Ouroboros — protokołu Proof of Stake, używanego przez Cardano do uzyskania konsensusu — zachęca do uczestniczenia w protokole poprzez zapewnienie zwrotu z inwestycji w postaci dodatkowej Ady. Dla zmaksymalizowania zysku stake pool nie może być przepełniony! Każdy pool z szansą na wydobycie bloku podlega "ryzyku" wyprodukowania więcej bloków może być za nie wynagrodzony. Dla małych pool'i to ryzyko jest bardzo małe, ale wraz ze wzrostem delegacji ryzyko rośnie. Każdy blok wyprodukowany ponad próg wynagrodzenia - zależnego od parametru "d" - byłby lepiej wykorzystany przez inne pool'e. Z czasem takie sytuacje obniżą możliwy zwrot z inwestycji dla pool'a bliskiego saturacji.</p>

<style>
	p {
		text-align: center;
		margin-left: 10px;
		margin-right: 10px;
	}
	img {
		margin-left: 10px;
		margin-right: 10px;
		filter:invert(80);
	}
	h3 {
		margin-top: 30px;
		font-size: 1.3em;
		color: lightseagreen;
	}
	h2 {
		margin-top: 30px;
		color: mediumpurple;
	}
	li {
		color: lavenderblush;
	}
	strong {
		color: azure;
	}

</style>

